import React, { useState } from "react";
import { Grid, IconButton, Tooltip, Typography, Divider } from "@mui/material";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import CloseIcon from "@mui/icons-material/Close";

const WasteLocationActionMenu = ({
  isEdit,
  onSave,
  onDelete,
  onClear,
  onExit,
  saveDisabled,
}) => {
  const [selectedButton, setSelectedButton] = useState(null);

  const handleClick = (btn) => {
    setSelectedButton(btn);
    if (btn === "save") onSave?.();
    if (btn === "delete") onDelete?.();
    if (btn === "clear") onClear?.();
    if (btn === "exit") onExit?.();
  };

  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item>
        <Typography variant="h4" sx={{ ml: 1 }}>
          {isEdit ? "Edit Waste Location" : "New Waste Location"}
        </Typography>
      </Grid>

      <Grid item>
        <Grid container alignItems="center">
          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

          <Tooltip title="Save Waste Location">
            <IconButton onClick={() => handleClick("save")} disabled={saveDisabled}>
              <SaveAltIcon
                sx={{ fontSize: 18, color: selectedButton === "save" ? "yellow" : "#009688" }}
              />
              <Typography variant="body2" sx={{ ml: 1 }}>Save</Typography>
            </IconButton>
          </Tooltip>

          {isEdit && (
            <>
              <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
              <Tooltip title="Delete Waste Location">
                <IconButton onClick={() => handleClick("delete")}>
                  <DeleteIcon sx={{ fontSize: 18, color: "#d72c0dff" }} />
                  <Typography variant="body2" sx={{ ml: 1 }}>Delete</Typography>
                </IconButton>
              </Tooltip>
            </>
          )}

          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

          <Tooltip title="Clear Form">
            <IconButton onClick={() => handleClick("clear")}>
              <ClearAllIcon sx={{ fontSize: 18, color: "#e0d620ff" }} />
              <Typography variant="body2" sx={{ ml: 1 }}>Clear</Typography>
            </IconButton>
          </Tooltip>

          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

          <Tooltip title="Close">
            <IconButton onClick={() => handleClick("exit")}>
              <CloseIcon sx={{ fontSize: 16, color: "#2196F3" }} />
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default WasteLocationActionMenu;
